module.exports = __webpack_public_path__ + "static/media/16.dfd43111.svg";